import React from 'react';
import * as ReactBootStrap from 'react-bootstrap';
import { Oval } from  'react-loader-spinner'
import git from '../Components/images/loading.gif'

const LoadingOverlay = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black background for blur effect
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999, // Make sure the overlay is on top of other elements
      }}
    >
      {/* Use the Spinner component as a function call 
      <MagnifyingGlass   visible={true}
height="15%"
width="15%"
  ariaLabel="MagnifyingGlass-loading"
  wrapperStyle={{}}
  wrapperClass="MagnifyingGlass-wrapper"
  glassColor = '#c0efff'
  color = '#e15b64' />*/}

<img src={git} alt="Loading..." />


      {/* ...Loading */}
    </div>
  );
};

export default LoadingOverlay;
